export const addApplicantFormOnFinish = async (
	props,
	values,
	location,
	params,
	navigate
) => {
	let error = false;
	let data = new FormData();
	data.append("id", params.id ? params.id : "");

	if (values.user_role_id === 4) {
		let response = await fetch(`/api/generate_school_id/student`);
		let school_id = await response.text();

		data.append("school_id", school_id);
	}

	// PROFILE PICTURE
	if (props.toggleModalUploadProfilePicture?.file) {
		data.append(
			"profile_picture",
			props.toggleModalUploadProfilePicture.file,
			props.toggleModalUploadProfilePicture.fileName
		);
	}

	// ACCOUNT INFORMATION
	const username = (
		values.firstname.split(" ")[0] +
		(values.middlename ? values.middlename.substring(0, 1) : "") +
		values.lastname
	)
		.replace(/\s+/g, "")
		.toLowerCase();

	data.append("username", username);

	data.append(
		"email",
		(
			values.firstname.split(" ")[0] +
			(values.middlename ? values.middlename.substring(0, 1) : "") +
			values.lastname
		)
			.replace(/\s+/g, "")
			.toLowerCase() + "@urios.edu.ph"
	);
	data.append(
		"password",
		values.lastname
			.split(" ")
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
			.join("")
			.replace(/\s+/g, "")
	);

	// BASIC INFORMATION
	const fieldsToCapitalize = [
		"firstname",
		"middlename",
		"lastname",
		"birthplace",
	];
	fieldsToCapitalize.forEach((field) => {
		if (values[field]) {
			data.append(field, props.capitalizeWords(values[field]));
		}
	});

	if (values.name_ext) {
		data.append("name_ext", values.name_ext);
	}

	if (values.birthdate) {
		data.append(
			"birthdate",
			props.dayjs(values.birthdate).format("YYYY-MM-DD")
		);
	}

	if (values.age) {
		data.append("age", values.age ? values.age : null);
	}

	if (values.gender) {
		data.append("gender", values.gender);
	}

	if (values.language) {
		values.language.forEach((id, index) => {
			data.append(`language[${index}]`, id);
		});
	}

	if (values.blood_type) {
		data.append("blood_type", values.blood_type);
	}
	if (values.height) {
		data.append("height", values.height);
	}
	if (values.weight) {
		data.append("weight", values.weight);
	}

	data.append("contact_number", values.contact_number);

	if (values.religion_id) {
		data.append("religion_id", values.religion_id);
	}

	if (values.civil_status_id) {
		data.append("civil_status_id", values.civil_status_id);
	}

	if (values.nationality_id) {
		data.append("nationality_id", values.nationality_id);
	}

	data.append("personal_email", values.personal_email);

	// --- PREVIOUS SCHOOL && ENTROLLED	 --- //
	if (values.previous_school_name) {
		data.append("previous_school_name", values.previous_school_name);
	}
	if (values.previous_school_year) {
		data.append(
			"previous_school_year",
			props.dayjs(values.previous_school_year).format("YYYY")
		);
	}
	if (values.applied_to_fsuu) {
		data.append("applied_to_fsuu", values.applied_to_fsuu);
	}
	if (values.year_applied) {
		data.append(
			"year_applied",
			props.dayjs(values.year_applied).format("YYYY")
		);
	}
	if (values.accepted_to_fsuu) {
		data.append("accepted_to_fsuu", values.accepted_to_fsuu);
	}
	if (values.year_accepted) {
		data.append(
			"year_accepted",
			props.dayjs(values.year_accepted).format("YYYY")
		);
	}
	if (values.attended_to_fsuu) {
		data.append("attended_to_fsuu", values.attended_to_fsuu);
	}
	if (values.year_attended) {
		data.append(
			"year_attended",
			props.dayjs(values.year_attended).format("YYYY")
		);
	}

	// HEALTH INFORMATION
	if (values.have_difficulty) {
		data.append("have_difficulty", values.have_difficulty);
	}
	if (values.difficulty_type) {
		data.append("difficulty_type", values.difficulty_type);
	}
	if (values.other_difficulty) {
		data.append("other_difficulty", values.other_difficulty);
	}
	if (values.have_disability) {
		data.append("have_disability", values.have_disability);
	}
	if (values.disability_type) {
		data.append("disability_type", values.disability_type);
	}
	if (values.other_disability) {
		data.append("other_disability", values.other_disability);
	}

	// ADDRESS INFORMATION
	if (values.address_list) {
		values.address_list.forEach((address, index) => {
			Object.keys(address).forEach((key) => {
				data.append(`address_list[${index}][${key}]`, address[key]);
			});
		});

		let formTemp = Array.isArray(props.form.getFieldValue("address_list"))
			? props.form.getFieldValue("address_list")
			: [];

		let homeAddressSelected = formTemp.some((item) => item.is_home_address);
		let currentAddressSelected = formTemp.some(
			(item) => item.is_current_address
		);

		if (
			props.location.pathname.includes("/profiling-portal") &&
			!props.location.pathname.includes("/add")
		) {
			if (!homeAddressSelected) {
				props.notification.error({
					message: "Basic Information",
					description: "Please select a home address.",
				});
				return;
			}

			if (!currentAddressSelected) {
				props.notification.error({
					message: "Basic Information",
					description: "Please select a current address.",
				});
				return;
			}
		}
	}

	// ENTRANCE EXAM INFORMATION
	if (values.student_level_id) {
		data.append("student_level_id", values.student_level_id);
	}
	if (values.current_course_id) {
		data.append("current_course_id", values.current_course_id);
	}
	data.append(
		"category",
		location.pathname.includes("walk-in") ? "Walk-In" : "Online"
	);
	data.append(
		"student_track",
		values.student_track ? values.student_track : null
	);
	data.append(
		"student_strand",
		values.student_strand ? values.student_strand : null
	);
	if (values.exam_category_id) {
		data.append("exam_category_id", values.exam_category_id);
	}
	if (values.student_status) {
		data.append("student_status", values.student_status);
	}

	// SCHOLARSHIP
	if (values.apply_scholarship) {
		data.append("apply_scholarship", values.apply_scholarship);
	}

	if (values.scholarship) {
		data.append("scholarship", values.scholarship);
	}

	// EXAM SCHEDULE INFORMATION
	data.append("exam_schedule_id", values.exam_schedule_id);

	// --- COURSES --- //
	if (values.exam_category_id !== 3) {
		if (values.first_course_id) {
			data.append("first_course_id", values.first_course_id);
		}
		if (values.second_course_id) {
			data.append("second_course_id", values.second_course_id);
		}
		if (values.third_course_id) {
			data.append("third_course_id", values.third_course_id);
		}
	}

	// --- DATA CONSENT --- //
	data.append("data_consent", props.stateDataConsent);

	// --- GENERATE QR --- //
	if (location.pathname.includes("/profiling-portal")) {
		let qrCodeFile = await props.convertQrCodeToImage(
			"myqrcode",
			"applicant_qr_code.png",
			"img_fsuulogo"
		);

		// check if qrCodeFile is successful
		if (qrCodeFile instanceof Error) {
			props.notification.error({
				message: "Applicant Basic Information",
				description: "QR Code generation failed.",
			});
			error = true;
		}

		data.append("qr_code_file", qrCodeFile);
		data.append("qr_code", props.qrCode);
		props.setQrCodeFile(qrCodeFile);
	}

	data.append("link_origin", process.env.REACT_APP_STUDENT_URL);

	if (!error) {
		// Notification
		props.mutateStudentCreate(data, {
			onSuccess: (res) => {
				if (res.success) {
					if (props.location.pathname !== "/profiling-portal/add") {
						props.notification.success({
							message: "Applicant Basic Information",
							description: res.message,
						});
					}
				} else {
					props.notification.error({
						message: "Applicant Basic Information",
						description: res.message,
					});
				}

				if (props.location.pathname.includes("add")) {
					props.setToggleModalProfile({
						open: true,
						data: null,
						username: username,
					});
				}
			},
			onError: (err) => {
				props.notificationErrors(err);
			},
		});
	}
};

export const editApplicantFormOnFinish = async (
	props,
	values,
	location,
	params,
	authPassword
) => {
	let data = new FormData();

	console.log("data editApplicantFormOnFinish: ", data);
	console.log("values editApplicantFormOnFinish: ", values);

	let username;
	let data2;

	username = values.username;

	let previous_school_year = props
		.dayjs(values.previous_school_year, "YYYY")
		.format("YYYY");
	let year_applied = values.year_applied
		? props.dayjs(values.year_applied, "YYYY").format("YYYY")
		: null;
	let year_accepted = values.year_accepted
		? props.dayjs(values.year_accepted, "YYYY").format("YYYY")
		: null;
	let year_attended = values.year_attended
		? props.dayjs(values.year_attended, "YYYY").format("YYYY")
		: null;

	data2 = {
		...values,
		previous_school_year: previous_school_year,
		year_applied: year_applied,
		year_accepted: year_accepted,
		year_attended: year_attended,
		profile_id: parseInt(params.id, 10),
		auth_password: authPassword,
		category: location.pathname.includes("walk-in") ? "Walk-In" : "Online",

		locationPathname: location.pathname,
	};

	// Append profile picture if it exists
	if (props.toggleModalUploadProfilePicture.file) {
		data.append("profile_picture", props.toggleModalUploadProfilePicture.file);
	}

	// Append ID
	data.append("id", params.id);

	// Append data2 properties to the FormData object `data`, excluding null or undefined values
	for (const key in data2) {
		if (
			data2.hasOwnProperty(key) &&
			data2[key] !== null &&
			data2[key] !== undefined
		) {
			data.append(key, data2[key]);
		}
	}

	props.mutateApplicantUpdate(data, {
		onSuccess: (res) => {
			if (res.success) {
				props.setToggleModalAuthPassword({
					open: false,
					data: null,
				});
				props.notification.success({
					message: "Applicant Basic Information Updated",
					description: res.message,
				});

				if (location.pathname.includes("/profiling-portal/edit")) {
					props.setToggleModalProfile({
						open: true,
						data: null,
						username: username,
						qrCode: props.qrCode,
					});
				}
			} else {
				props.notification.error({
					message: "Applicant Schedule Failed",
					description: res.message,
				});
			}
		},
		onError: (err) => {
			props.notificationErrors(err);
		},
	});
};
